import axios from './BaseService';

const Filiados_URL = `${process.env.REACT_APP_API_URL}/users/`;

export async function getActiveFiliados(token) {
    const headers = { 'authorization': token };
    const response = await axios.get(`${Filiados_URL}active`, { headers });
    return response.data;
}

export async function getFiliados(search, page, token) {
    const FiliadosUrl = `${Filiados_URL}${search ? search : ''}?page=${page}`;

    const headers = { 'authorization': token };
    const response = await axios.get(FiliadosUrl, { headers });
    return response.data;//{count, rows}
}

export async function getFiliado(id, token) {
    const FiliadosUrl = `${Filiados_URL}id/${id}`;
    const headers = { 'authorization': token }
    console.log('========filiados==========');
    console.log(FiliadosUrl);

    const response = await axios.get(FiliadosUrl, { headers });
    return response.data;
}



export async function saveFiliado(id, newFiliado, token) {
    const headers = { 'authorization': token };
    let response;
    if (id)
        response = await axios.patch(`${Filiados_URL}${id}`, newFiliado, { headers });
    else
        response = await axios.post(Filiados_URL, newFiliado, { headers });
    return response.data;
}

export async function deleteFiliado(id, token) {
    const headers = { 'authorization': token };
    const response = await axios.delete(`${Filiados_URL}${id}`, { headers });
    return response.data;
}

export async function getIndicacoes(id, token) {
    const indicacoesUrl = `${Filiados_URL}indi/id/${id}`;
    const headers = { 'authorization': token }
    console.log('local das pessoas que me indicaram--->');
    console.log(indicacoesUrl);
    const response = await axios.get(indicacoesUrl, { headers });
    return response.data;
}